let instance
const KEY_NAME = 'achievements'
export class AchievementDAO {
  static getInstance() {
    if (!instance) {
      instance = new AchievementDAO()
    }
    return instance
  }

  readData() {
    let records = window.localStorage.getItem(KEY_NAME)
    if (records) return JSON.parse(records)

    return {}
  }

  writeData(records) {
    window.localStorage.setItem(KEY_NAME, JSON.stringify(records))
  }

  truncate() {
    window.localStorage.removeItem(KEY_NAME)
  }
}



// WEBPACK FOOTER //
// ./src/components/common/achievement/AchievementDAO.js